import React, { useState } from 'react'
import { MDBRow, MDBCol, MDBInputGroup } from 'mdb-react-ui-kit';
import { useDispatch } from 'react-redux'
import { addEmailRecipient } from '../features/emailCollection/emailCollectionSlice';

const PelvicProgramBanner8 = ({ width }) => {

    const [newsletterEmail, setNewsletterEmail] = useState("");

    const dispatch = useDispatch()

    const addEmailToNewsletterList = (email) => {
        dispatch(addEmailRecipient({ email: email, type: "Newsletter" }));
        setNewsletterEmail("");
      };


  return (
    <>
        <div className="cta-pelvic-care-program">
            <h1 className="text-al text-black fs-32-24 mx-2 padding-letters-mobile">
              We’ll only send you the important stuff.
            </h1>
            <MDBRow>
              <MDBCol sm="12" md="6" className="d-flex ">
                <p className="m-0 text-dm text-gray fs-20-16 mx-2 padding-letters-mobile">
                  Sign up to get updates from Elana and the latest on pelvic
                  care delivered right to your inbox.
                </p>
              </MDBCol>
              <MDBCol
                sm="12"
                md="6"
                className="d-flex justify-content-center align-items-center"
              >
                <MDBInputGroup className="newsletter-input-width border-radius-8 text-dm input-homepage-cta">
                  <input
                    className="text-dm text-spacing-minus-1 border-radius-8 form-control update-input-padding"
                    placeholder="Enter your email"
                    type="text"
                    value={newsletterEmail}
                    onChange={(e) => {
                      setNewsletterEmail(e.target.value);
                    }}
                  />
                  <button
                    onClick={() => addEmailToNewsletterList(newsletterEmail)}
                    className="brand-bg-purple py-2 px-4 border-0 text-white blue-hover text-dm border-radius-end-8"
                  >
                    SIGN UP
                  </button>
                </MDBInputGroup>
              </MDBCol>
            </MDBRow>
            <p className="margin-disclaimer text-dm py-3 px-2 fs-12 text-gray mobile-view-hidden">
              Disclaimer: The information provided through Elana Health website
              and services is not intended or implied to be a substitute for
              professional medical advice, diagnosis or treatment.
            </p>
          </div>
    </>
  )
}

export default PelvicProgramBanner8